/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import {
  Page,
  PageActions,
  Layout,
  TextStyle,
  Banner,
  Card,
  Tabs,
  Icon,
  Link,
  Stack
} from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import GeneralTab from './general-tab';
import RecentlyViewedTab from './recently-viewed-tab';
import MostPopularTab from './most-popular-tab';
import Preview from './preview';
import MainMenu from 'src/components/containers/main-menu';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
// import YoutubeModal from 'src/components/views/common/youtube-modal';
import RouteLeavingGuard from 'src/components/views/common/handle-leave/route-leaving-guard';

import { URL } from 'src/constants/links';
import { confirmLeavePage } from 'src/helpers';
import {
  buildInitialDefaultLayoutSettingsValues,
  buildDefaultLayoutSettingsValues
} from 'src/helpers/default-layout-settings-helper';
import * as FilterSettingsActions from 'actions/filter-settings-actions';

import type { ComposedProps, State } from './index.type';

class DefaultLayoutSettings extends Component<ComposedProps, State> {
  state = {
    selected: 0
    // youtubeModal: false
  };

  componentDidMount() {
    const { getFilterSettings } = this.props;

    getFilterSettings();

    // Handle when reload or leave page
    window.addEventListener('beforeunload', this.confirmLeavePage);
  }

  componentWillUnmount() {
    // Handle when reload or leave page
    window.removeEventListener('beforeunload', this.confirmLeavePage);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loadingFilterSettings && !this.props.loadingFilterSettings) {
      startSABLoading();
    }

    if (!nextProps.loadingFilterSettings && this.props.loadingFilterSettings) {
      stopSABLoading();
    }
  }

  render() {
    const {
      dirty,
      submitting,
      handleSubmit,
      pristine,
      savingFilterSettings,
      initialValues,
      enableMostPopular,
      enableRecentlyViewed,
      history,
      i18n
    } = this.props;
    const { selected } = this.state;
    // const { selected, youtubeModal } = this.state;

    // const tabs = [
    //   {
    //     id: 'general',
    //     content: 'General',
    //     panelID: 'general'
    //   },
    //   {
    //     id: 'recentlyViewed',
    //     content: 'Recently viewed',
    //     panelID: 'recentlyViewed'
    //   },
    //   {
    //     id: 'MostPopular',
    //     content: 'Most popular',
    //     panelID: 'mostPopular'
    //   }
    // ];

    // const tabComponents = [
    //   <GeneralTab initialValues={initialValues} />,
    //   <RecentlyViewedTab />,
    //   <MostPopularTab />
    // ];

    // Open Most Popular and Recently Viewed by flags
    // Waiting for the readiness of lib V2 for these features
    let tabs = [
      {
        id: 'general',
        content: i18n.translate(
          'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.tab1_Content'
        ),
        panelID: 'general'
      }
    ];

    let tabComponents = [<GeneralTab initialValues={initialValues} />];

    if (enableRecentlyViewed) {
      tabs.push({
        id: 'recentlyViewed',
        content: i18n.translate(
          'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.tab2_Content'
        ),
        panelID: 'recentlyViewed'
      });
      tabComponents.push(<RecentlyViewedTab />);
    }

    if (enableMostPopular) {
      tabs.push({
        id: 'MostPopular',
        content: i18n.translate(
          'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.tab3_Content'
        ),
        panelID: 'mostPopular'
      });
      tabComponents.push(<MostPopularTab />);
    }

    return (
      <div className="BC-Page BC-Page__Layout-Settings">
        <MainMenu menuId="menu-theme-default-layout-settings" />
        <Page
          title={i18n.translate('AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.pageTitle')}
          titleMetadata={
            <Stack spacing="tight">
              <span className="titleMetadata">
                <a href={URL['DefaultLayoutSettingsDoc']} target="_blank" rel="noopener noreferrer">
                  <Icon source={QuestionMarkMajor} color="base" />
                </a>
              </span>
              {/* <span className="titleMetadata">
                <button onClick={this.handleOpenYoutubeModal}>
                  <Icon source={PlayCircleMajor} color="base" />
                </button>
              </span> */}
            </Stack>
          }>
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                <Banner
                  title={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.bannerTitle'
                  )}
                  status="info">
                  <TextStyle>
                    {i18n.translate(
                      'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.textStyle_Content',
                      {
                        t: (
                          <Link external url={URL['ShopifyThemes']}>
                            {i18n.translate(
                              'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.textStyle_Content_t'
                            )}
                          </Link>
                        )
                      }
                    )}
                  </TextStyle>
                </Banner>

                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />

              </div>
            </Layout.Section>
            <Layout.Section>
              <div className={`tabs${selected === 0 ? ' tabs-with-preview' : ''}`}>
                <Card sectioned>
                  <Layout>
                    <Layout.Section>
                      <Card sectioned>
                        <div className="tab-content">
                          <form onSubmit={this.handleDefaultSubmit}>
                            <Tabs tabs={tabs} selected={selected} onSelect={this.handleTabChange}>
                              <Card.Section>{tabComponents[selected]}</Card.Section>
                            </Tabs>
                          </form>
                        </div>
                      </Card>
                    </Layout.Section>
                    {selected === 0 && (
                      <Layout.Section secondary>
                        <Preview />
                      </Layout.Section>
                    )}
                  </Layout>
                </Card>
              </div>
            </Layout.Section>
          </Layout>
          <PageActions
            primaryAction={{
              content: i18n.translate('AdminHTML.Common.Action.saveSettings'),
              onAction: handleSubmit(this.handleSave.bind(this)),
              disabled: pristine || submitting,
              loading: savingFilterSettings && !pristine
            }}
            secondaryActions={
              !pristine
                ? [
                    {
                      content: i18n.translate('AdminHTML.Common.Action.cancel'),
                      onAction: this.discardChange
                    }
                  ]
                : []
            }
          />
        </Page>
        {/* <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['DefaultLayoutSettingsTut']}
          title={i18n.translate(
            'AdminHTML.DefaultLayoutSettings.DefaultLayoutSettings.youtubeModal_Title'
          )}
          onClose={this.handleCloseYoutubeModal}
        /> */}

        {/* Confirm before leaving */}
        <RouteLeavingGuard
          when={dirty}
          // Navigate function
          navigate={path => history.push(path)}
          shouldBlockNavigation={dirty}
        />
      </div>
    );
  }
  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  // Handle change tab
  handleTabChange = (selectedTabIndex: number) => {
    this.setState({ selected: selectedTabIndex });
  };

  // Handle click save button
  handleSave = data => {
    const { updateFilterSettings, filterSettings } = this.props;
    const saveData = buildDefaultLayoutSettingsValues(data, filterSettings);
    updateFilterSettings(saveData);
  };

  discardChange = () => {
    const { resetForm } = this.props;

    resetForm();
  };

  // handleOpenYoutubeModal = () => this.setState({ youtubeModal: true });
  // handleCloseYoutubeModal = () => this.setState({ youtubeModal: false });

  // Handle confirm leave page
  confirmLeavePage = event => {
    const { dirty, i18n } = this.props;
    return confirmLeavePage(event, dirty, i18n);
  };
}

const DefaultLayoutSettingsForm = reduxForm({
  form: 'DefaultLayoutSettingsForm', // a unique identifier for this form
  enableReinitialize: true
})(DefaultLayoutSettings);

const mapDispatchToProps = (dispatch, ownProps) => ({
  getFilterSettings: () =>
    dispatch(FilterSettingsActions.getFilterSettings(undefined, ownProps.i18n)),
  updateFilterSettings: (filterSettings: Object) =>
    dispatch(
      FilterSettingsActions.updateFilterSettings(
        filterSettings,
        'defaultLayoutSettings',
        undefined,
        ownProps.i18n
      )
    ),
  resetForm: () => dispatch(reset('DefaultLayoutSettingsForm'))
});

const mapStateToProps = (state, props) => {
  const adminAppFeatures = _.get(state.oauth.tenantApp, 'adminAppFeatures', {});

  const { filterSettings } = state;
  return {
    filterSettings: filterSettings.filterSettings,
    loadingFilterSettings: filterSettings.loadingFilterSettings,
    savingFilterSettings: filterSettings.savingFilterSettings,
    initialValues: buildInitialDefaultLayoutSettingsValues(filterSettings.filterSettings),
    enableMostPopular: _.get(adminAppFeatures, 'enableMostPopular', true),
    enableRecentlyViewed: _.get(adminAppFeatures, 'enableRecentlyViewed', true)
  };
};
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(DefaultLayoutSettingsForm));
